import React from 'react'
import useSWRImmutable from 'swr/immutable'

import { getCompanyDivisions, getCompanySubDivisions } from '../../../api/companies'
import Loading from '../../components/layout/Loading'
import CompanySubDivisions from './SubDivisionsList'
import type { CompanyDivision } from '../../../api/companies/types'

type Props = { companyId: number }
const DivisionsList: React.FC<Props> = ({ companyId }) => {
  const { data, isLoading } = useSWRImmutable(['company', companyId, 'divisions'], () => getCompanyDivisions(companyId))

  if(isLoading) { return <Loading /> }

  return (
    <div>
      {data && data.length === 0 && <div>No divisions found</div>}
      {data?.map((division) => (
        <Division key={`division-${division.id}`} division={division} companyId={companyId} />
      ))}
    </div>
  )
}

type DivisionProps = { companyId: number, division: CompanyDivision }
const Division: React.FC<DivisionProps> = ({ companyId, division }) => {
  const { data: subDivisions, isLoading: isLoadingSubDivisions } = useSWRImmutable(['company', companyId, 'divisions', division.id], () => getCompanySubDivisions(companyId, division.id))

  if(isLoadingSubDivisions) { return <Loading /> }
  if(!subDivisions || subDivisions.length === 0) { return null }

  return (
    <div key={division.name} className='my-8 bg-white p-4 sm:p-8 rounded-lg'>
      <h3 className='mb-4 sm:mb-0'>{division.name}</h3>
      <CompanySubDivisions companyId={companyId} divisionId={division.id} />
    </div>
  )
}

export default DivisionsList
